export default[ 
  'Trainees',
  'Becarios',
  'Otros servicios',
]